import React from 'react'
import { Col, Radio, Row } from 'react-bootstrap'

function RadioWithLabel({ onChange, value, label, name }) {
  return (
    <Row className="align-items-center flex-column">
      <Col>
        <div>{label}</div>
      </Col>
      <Col>
        <Radio
          name={name}
          checked={value}
          onChange={onChange}
        />
      </Col>
    </Row>
  )
}

export default RadioWithLabel



// WEBPACK FOOTER //
// ./src/component/Form/RadioWithLabel.js